<template>
 <div class="kpi">
    <v-skeleton-loader
      v-if="cargandoDatos"
      class="cargando"
      type="image"
      height="400px"
      max-height="400px"
    ></v-skeleton-loader>
    <div v-else>
      <div class="graficaVacia" v-if="graficaVacia">
        <v-chip>No existen registros</v-chip>
      </div>
      <div v-if="!graficaVacia" class="canvas">
        <highcharts :options="chartOptions"></highcharts>
      </div>
    </div>
  </div>
</template>
<script>
import { Chart } from "highcharts-vue";
import {
  obtenerEtiquetasMeses,
  obtenerDatasetsMeses,
} from "../../utils/datasets.js";
import obtenerDatosKPI from "../../services/graficas/obtenerDatos";
export default {
  name: "EvolucionIngresoMuestras",
  props: {
    selectedCountry: {
      type: String,
      default: 'argentina',
    },
  },
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      cargandoDatos: true,
      chartOptions: {
        credits: {
          enabled: false,
        },
        chart: {
          zoomType: "x",
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          allowDecimals: false,
          title: {
            text: "Número de muestras",
          },
        },
        tooltip: {
          shared: true,
          useHTML: true,
          formatter: function() {
            // Obtenemos todos los puntos en esta posición x
            const points = this.points;
            
            // Filtramos para mostrar solo los puntos con valores mayores a cero
            const pointsWithValues = points.filter(point => point.y > 0);
            
            // Calculamos el total
            let total = 0;
            points.forEach(function(point) {
              total += point.y;
            });
            
            // Si no hay puntos con valores > 0, mostramos solo el total
            if (pointsWithValues.length === 0) {
              let html = '<table style="border-collapse: collapse; width: 100%;">';
              html += '<tr><th style="text-align: center; padding: 5px;">';
              html += '<b>' + this.x + '</b> - <b>Total: ' + total + '</b>';
              html += '</th></tr>';
              html += '</table>';
              return html;
            }
            
            // Creamos un tooltip de dos columnas para ahorrar espacio
            let html = '<table style="border-collapse: collapse; width: 100%;">';
            
            // Título con el mes y el total
            html += '<tr><th colspan="4" style="text-align: center; padding-bottom: 5px; border-bottom: 1px solid #ddd;">';
            html += '<b>' + this.x + '</b> - <b>Total: ' + total + '</b>';
            html += '</th></tr>';
            
            // Filas de países en formato de 2 columnas (solo para valores > 0)
            let itemsPerRow = 2; // Número de países por fila
            let currentCol = 0;
            
            for (let i = 0; i < pointsWithValues.length; i++) {
              const point = pointsWithValues[i];
              
              // Comenzar una nueva fila si es necesario
              if (currentCol === 0) {
                html += '<tr>';
              }
              
              // Agregar el país y su valor
              html += '<td style="padding: 2px 5px; white-space: nowrap;">' + 
                     '<span style="color:' + point.series.color + ';">●</span> ' + 
                     point.series.name + ': </td>' +
                     '<td style="padding: 2px 5px; text-align: right; font-weight: bold;">' + 
                     point.y + '</td>';
              
              currentCol++;
              
              // Cerrar la fila si es necesario
              if (currentCol === itemsPerRow || i === pointsWithValues.length - 1) {
                // Si estamos en la última iteración y no completamos la fila, añadimos celdas vacías
                if (i === pointsWithValues.length - 1 && currentCol < itemsPerRow) {
                  for (let j = currentCol; j < itemsPerRow; j++) {
                    html += '<td colspan="2"></td>';
                  }
                }
                html += '</tr>';
                currentCol = 0;
              }
            }
            
            html += '</table>';
            return html;
          }
        },
        series: [],
      },
      graficaVacia: false,
      filtros: this.$store.state.filtros,
    };
  },
  watch: {
    filtros: {
      handler() {
        this.actualizarGrafica();
      },
      deep: true,
    },
    selectedCountry() {
      this.actualizarGrafica();
    },
  },
  methods: {
    actualizarGrafica() {
      if (this.filtros.fecha.desde) {
        this.cargandoDatos = true;
        this.chartOptions.xAxis.categories = [];
        this.chartOptions.series = [];
        obtenerDatosKPI(
          this,
          '/evolucion-muestras', 
          this.$store.getters.objetoPeticion(), 
          this.selectedCountry,
          process.env.VUE_APP_URL_MS 
        )
          .then((resp) => {
            if (resp.length > 0) {
              const etiquetas = obtenerEtiquetasMeses(resp);
              this.chartOptions.xAxis.categories = etiquetas;
              this.chartOptions.series = obtenerDatasetsMeses(resp, etiquetas);
              this.graficaVacia = false;
            } else {
              this.graficaVacia = true;
            }
            this.cargandoDatos = false;
          });
      }
    },
  },
  created() {
    this.actualizarGrafica();
  },
};
</script>
<style scoped>
.kpi {
  min-height: 400px;
}
.graficaVacia {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  font-weight: 500;
}
</style>